// ========================================
// COMPONENTS / Marquee.jsx
// ========================================

import React from "react";
import { MARQUEE_TEXT } from "../data";
import styles from "./Marquee.module.css";

export default function Marquee() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        {Array(8)
          .fill(null)
          .map((_, i) => (
            <span key={i} dangerouslySetInnerHTML={{ __html: MARQUEE_TEXT }} />
          ))}
      </div>
    </div>
  );
}
